import { makeStyles } from '@fluentui/react-components';
import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import AzureProductIcon from '../../../content/images/Azure-A-32px-product.svg';

interface ProductImageProps {}

const messages = defineMessages({
    imageAlt: {
        id: 'AzureProductImage_Image_Alt',
        defaultMessage: 'Azure Deployment Environments',
        description: 'Alt text for product image',
    },
});

/**
 * Styles
 */

const useStyles = makeStyles({
    root: {
        height: '20px',
        width: '20px',
    },
});

/**
 * END Styles
 */

export const AzureProductImage: React.FC<ProductImageProps> = React.memo(() => {
    // Intl hooks
    const { formatMessage } = useIntl();

    // Style hooks
    const styles = useStyles();

    return <img alt={formatMessage(messages.imageAlt)} className={styles.root} src={AzureProductIcon} />;
});

export default AzureProductImage;
